exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-new-image {\n  position: relative;\n}\n\n.add-new-image input[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  height: 150px;\n  width: 150px;\n}\n\ndiv.item-image {\n  position: relative;\n  height: 100px;\n  width: 100px;\n  float: left;\n  margin-left: 10px;\n  margin-top: 10px;\n}\n\na.btn-delete img {\n  position: absolute;\n  right: -10px;\n  top: -2px;\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/product/product-store-add/product-store-add.component.css
// module id = ../../../../../src/app/pages/admin/evs/product/product-store-add/product-store-add.component.css
// module chunks = 3